import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './AgeVerification.css';

const AgeVerification = ({ onVerified, onDecline }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleYes = () => {
    setIsVisible(false);
    if (onVerified) onVerified();
  };

  const handleNo = () => {
    // Callers that only display the disclaimer (the footer link) opt out of
    // the redirect; without a handler, underage visitors are sent away
    if (onDecline) {
      onDecline();
      return;
    }
    window.location.href = 'https://www.google.com';
  };

  useEffect(() => {
    // Prevent scrolling when modal is open
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isVisible]);

  if (!isVisible) return null;

  // Portalled to body so the overlay always centres on the viewport. Rendered
  // in place it would anchor to any ancestor with a filter/transform - the
  // footer's backdrop-filter did exactly that and pinned the modal to the footer
  return createPortal(
    <div className="age-verification-overlay">
      <div className="age-verification-modal">
        <div className="age-verification-content">
          <div className="age-verification-logo">
            <img src="/chilltree-images/Chill tree White.png" alt="Chilltree Logo" className="logo-image" />
          </div>
          
          <h2 className="age-verification-title">Are you over 21?</h2>
          
          <div className="age-verification-message">
            <p className="age-verification-subtitle">
              You must be at least 21 years old to enter. By clicking 'Yes', you confirm that you meet this age requirement.
            </p>
          </div>

          <div className="age-verification-buttons">
            <button 
              className="age-verification-btn age-verification-btn-yes"
              onClick={handleYes}
            >
              Yes
            </button>
            <button 
              className="age-verification-btn age-verification-btn-no"
              onClick={handleNo}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AgeVerification;


